import React from "react";

const About = () => {
	return (
		<section
			id="About"
			className="about  py-8 md:py-16 w-full bg-gradient-to-b from-gray-800 to-black text-white">
			<div className="container  m-auto h-full px-8  lg:px-16 ">
				<div className="about__content ">
					<div className="about__content__title mb-12">
						<h3 className="text-4xl font-bold inline border-b-4 border-gray-500">
							About
						</h3>
					</div>
					<p className="text-xl text-gray-400">
						I am passionate frontend developer from Egypt I Graduated from
						faculty of commerce department of Business information systems,
						Helwan university (2016- 2020) with Very Good grade.Seeking a job in
						the field of “Front End Development” in a reputable organization
						where gain experience. Eager to learn every day and gain more
						experience in different fields related to technology
					</p>
				</div>
			</div>
		</section>
	);
};

export default About;
